import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { Btn } from "@/components/Btn";
import { CTA } from "@/lib/brand";
import { PawPrint, Heart, Recycle } from "lucide-react";

export default function GiveBack() {
  return (
    <>
      <Seo path="/give-back" title="Give Back" description="Skedaddle Junk Removal gives back to local animal shelters across the Lowcountry. When your junk skedaddles, a little good goes with it." />
      <PageHero eyebrow="Give back" title="Junk that does some good!" subtitle="We love our four legged neighbors, so giving back is baked into what we do." />
      <section className="bg-white py-16 md:py-24">
        <div className="mx-auto max-w-3xl px-4 md:px-8">
          <div className="bg-sunny border-2 border-charcoal rounded-[2rem] shadow-brutlg p-8 md:p-12 text-center">
            <div className="w-24 h-24 mx-auto rounded-full border-2 border-charcoal bg-cream flex items-center justify-center"><PawPrint className="w-12 h-12 text-coral" /></div>
            <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl tracking-tight">We give back to local animal shelters.</h2>
            <p className="mt-4 font-body text-lg text-charcoal/80">Every load we haul helps support animal shelters right here in the Lowcountry. It is a small way for us to say thanks to the community that welcomes us onto its driveways every day.</p>
            <p className="mt-3 font-body text-charcoal/70">We will be sharing more about exactly how we pitch in soon. For now, just know that when you call Skedaddle, a little good tags along with your junk!</p>
          </div>
          <div className="mt-8 grid sm:grid-cols-2 gap-5">
            <div className="bg-cream border-2 border-charcoal rounded-3xl p-6 shadow-brut">
              <Heart className="w-8 h-8 text-coral mb-3" />
              <h3 className="font-heading font-bold text-xl">Local first</h3>
              <p className="mt-1 font-body text-charcoal/70">Our giving stays right here in Charleston, Berkeley and Dorchester counties.</p>
            </div>
            <div className="bg-cream border-2 border-charcoal rounded-3xl p-6 shadow-brut">
              <Recycle className="w-8 h-8 text-teal mb-3" />
              <h3 className="font-heading font-bold text-xl">Second life</h3>
              <p className="mt-1 font-body text-charcoal/70">We donate and recycle whenever we can, so good stuff finds a new home.</p>
            </div>
          </div>
          <div className="mt-12 text-center"><Btn to="/contact" variant="primary">{CTA.quote}</Btn></div>
        </div>
      </section>
    </>
  );
}
